import React from "react";
import { KgCollapsedNodeHover } from "../KgCollapsedNodeHover";
import { rawColors } from "../../../design-system/tokens/colors";
import {
  KG_DATA_MODEL_CUBE_VIEWBOX,
  KG_DATA_MODEL_CUBE_BODY_PATH,
  KG_DATA_MODEL_CUBE_BODY_OFFSET,
  KG_DATA_MODEL_CUBE_SEAM_PATH,
  KG_DATA_MODEL_CUBE_SEAM_OFFSET,
} from "./kgDataModelCubeShape";
import {
  Root,
  CubeShape,
  Content,
  IconBox,
  TextSection,
  Label,
  Name,
  cubeStrokeProps,
} from "./KgDataModelNodeCard.styles";
import type { KgDataModelNodeCardProps } from "./KgDataModelNodeCard.types";

const DataModelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <polygon points="12 2 2 7 12 12 22 7 12 2" />
    <polyline points="2 17 12 22 22 17" />
    <polyline points="2 12 12 17 22 12" />
  </svg>
);

const DataModelCubeShape: React.FC<{
  visualState: KgDataModelNodeCardProps["visualState"];
}> = ({ visualState = "default" }) => {
  const stroke = cubeStrokeProps(visualState);

  return (
    <CubeShape
      viewBox={KG_DATA_MODEL_CUBE_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g
        transform={`translate(${KG_DATA_MODEL_CUBE_BODY_OFFSET.x} ${KG_DATA_MODEL_CUBE_BODY_OFFSET.y})`}
      >
        <path
          d={KG_DATA_MODEL_CUBE_BODY_PATH}
          fill={rawColors.structural.white}
          {...stroke}
        />
      </g>
      <g
        transform={`translate(${KG_DATA_MODEL_CUBE_SEAM_OFFSET.x} ${KG_DATA_MODEL_CUBE_SEAM_OFFSET.y})`}
      >
        <path
          d={KG_DATA_MODEL_CUBE_SEAM_PATH}
          fill={rawColors.structural.white}
          {...stroke}
        />
      </g>
    </CubeShape>
  );
};

export const KgDataModelNodeCard: React.FC<KgDataModelNodeCardProps> = ({
  name,
  collapsed = false,
  visualState = "default",
  isSelected = false,
  onClick,
}) => {
  if (collapsed) {
    return (
      <KgCollapsedNodeHover
        icon={<DataModelIcon />}
        color={rawColors.accent.dataModelRed}
        bgColor={rawColors.accent.dataModelRedBg}
        visualState={visualState}
        title={name}
        subtitle="Data Model"
      />
    );
  }

  return (
    <Root
      $isSelected={isSelected}
      $visualState={visualState}
      onClick={onClick}
      role="group"
      tabIndex={0}
    >
      <DataModelCubeShape visualState={visualState} />
      <Content>
        <IconBox>
          <DataModelIcon />
        </IconBox>
        <TextSection>
          <Label>Data model</Label>
          <Name title={name}>{name}</Name>
        </TextSection>
      </Content>
    </Root>
  );
};

export default KgDataModelNodeCard;
